import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Grid } from '@mui/material';
// const querystring = require("querystring");

const HomePage = () => {

    return (
    	<>
        <h4>Infrastructure Status</h4>
					<Grid>
					<iframe src="https://p.us5.datadoghq.com/sb/embed/60d955af-6641-11f0-850f-12cb51e282ae-2296e802cb7296254e603a5ed6e55528" 
						frameBorder="0"
						title="Dashboard Name" width="100%" height="400">
					</iframe>
					</Grid>
    	

            <div class="container-fluid">
            <div class="container">
                    <div class="row">
                        <div class="col-md">
                            <h4>Infrastructure</h4>

        <p>
          <a href="/telony" className="ContentTitle">
            Servers
          </a>
        </p>
        <p>
          <a href="/telony" className="ContentTitle">
            Databases
          </a>
        </p>
        <p>
          <a href="/neo/services" className="ContentTitle">
            Services
          </a>
        </p>
        <p>
          <a href="/telony" className="ContentTitle">
            Networking
          </a>
        </p>
        <p>
          <a href="/dynamo/LayoutDetails" className="ContentTitle">
            Websites
          </a>
        </p>
		</div>
		</div>
		</div>
		</div>
        
    	{/*-- 
    		iframe src="https://onenr.io/MTAwODY5MnxWSVp8REFTSEJPQVJEfGRhOjEwNDc2NjIw?account=1008692&tv-mode&state=38862c15-dec7-5349-716c-4e06899ebb8f" 
    		frameborder="0"
    		width="100%"
    		height="600"
    	--*/}
    	
    	
    	


      </>
    );
}

export default HomePage;